import { UsersDialogBaseComponent } from "./users-dialog-base/users-dialog-base.component";
import { Component, Injector, OnInit } from "@angular/core";
import {NewPasswordViewModel, UserCreateViewModel, UserViewModel} from "../../../services/users.service";

@Component({
    selector: 'app-create-user',
    templateUrl: './users-dialog-base/users-dialog-base.component.html',
    styleUrls: ['./users-dialog-base/users-dialog-base.component.css'],
    standalone: false
})
export class CreateUserComponent extends UsersDialogBaseComponent<UserCreateViewModel> implements OnInit {

  currentUser: UserViewModel;
  constructor(protected injector: Injector) {
    super(injector);
    this.dialogId = "createUser";
  }

  async ngOnInit() {
    super.ngOnInit();
    this.model.CompanyId = undefined;
    /*
    this.currentUser = this.usersService.getCurrentUser();
    // Because company id does not returns
    this.currentUser.CompanyId = this.users.filter(u => u.Id == this.currentUser.Id)[0].CompanyId;

    this.model.CompanyId = this.currentUser.CompanyId;
    */
  }

  public submit() {
    this.model.Id = 0;

    if (this.model.CompanyId == undefined) {
      this.toastr.error(this.translateService.instant("Company required"));
      return;
    }

    if (this.model.Password != this.model.PasswordConfirmation) {
      this.toastr.error(this.translateService.instant("Password and confirmation do not match"));
      return;
    }

    if (!this.model.Password) {
      this.toastr.error(this.translateService.instant("Password is required"));
      return;
    }

    this.usersService.createUser(this.model)
      .subscribe((res) => {
        const pass = new NewPasswordViewModel();
        pass.UserId = res?.Id;
        pass.Password = this.model.Password;
        pass.PasswordConfirmation = this.model.PasswordConfirmation;
        // this.usersService.changeUserPassword(pass).subscribe((res) => { });

        this.onCreated.emit();
        this.close();
        super.submit();
      });
  }
}
